export {};
//# sourceMappingURL=props.js.map